import _ from 'lodash';
import React, { useContext, useState, useEffect } from 'react';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Ownership from 'src/models/tract_detail/Ownership';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import useFetch from 'use-http';
import Card from 'src/components/common/Card.redesign';
import AddressUtil from 'src/util/Address';

export interface IManageContactCategoriesDialogProps {
    ownerships?: Array<Ownership>;
    onDetach?: () => void;
    onCloseDialog?: () => void;
}

const ManageContactCategoriesDialog = (props: IManageContactCategoriesDialogProps) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const { post, response } = useFetch();

    const [ownershipList, setOwnershipList] = useState<Array<Ownership>>([]);

    useEffect(() => {
        if (props?.ownerships?.length > 0) {
            setOwnershipList(props.ownerships);
        }
    }, [props]);

    const handleOwnershipDetached = (ownershipId: number) => {
        let newList = [...ownershipList];
        newList.splice(newList.indexOf(newList.find(nl => nl.id === ownershipId)), 1);
        setOwnershipList(newList);
        props.onDetach();
    };

    const confirmDetachOwnership = async (ownership: Ownership) => {
        ownership.ownershipContactCategoryId = null;

        await post(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/fields/${appContext.fieldNumber}/tracts/save-ownership-detail`, ownership);

        if (response.ok) {
            handleOwnershipDetached(ownership.id);
        } else {
            window.alert('detach ownership failed');
        }
    };

    const ownershipCards = () => {
        if (ownershipList.length > 0) {
            return (
                <div style={{ marginBottom: '1rem', width: '60vw' }}>
                    <div>Please address attached ownerships before removing Contact Category from Project.</div>
                    <div>
                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                            <legend className="legend">Attached Ownerships</legend>
                        </fieldset>
                    </div>
                    <CardContainer>
                        {ownershipList.map((os: Ownership, index: number) => {
                            const owner = os.ownerInfo;

                            return (
                                <div key={index}>
                                    <Card
                                        badge={`${os.id}`}
                                        newContext={true}
                                        showMenu={true}
                                        className="small-input"
                                    >
                                        <div
                                            key={os.id}
                                            style={{ minHeight: '5rem', margin: '1.3rem 1rem 0 1rem', display: 'flex', justifyContent: 'space-between' }}
                                        >
                                            <div style={{ paddingLeft: '2.5rem', fontSize: '1.6rem' }}>
                                                {owner && (
                                                    <>
                                                        {owner.name}
                                                        <div style={{ fontSize: '1.4rem' }}>{AddressUtil.concatWithCommas(owner.addressLine1, owner.city, owner.state)}</div>
                                                    </>
                                                )}
                                            </div>

                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <div style={{ fontSize: '1.4rem', padding: '1.4rem', margin: 'auto' }}>{os.contactCategory}</div>
                                                <Button style={{ margin: 'auto' }} text="Detach" onClick={() => confirmDetachOwnership(os)} intent="primary" />
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            );
                        })}
                    </CardContainer>
                    <br />
                    <div className="mt-2 button-row">
                        <Button text="OK" onClick={props.onCloseDialog} intent="primary" />
                    </div>
                </div>
            );
        }
        return (
            <div className="mt-2 button-row">
                <Button text="OK" onClick={props.onCloseDialog} intent="primary" />
            </div>
        );
    };

    return (
        <Dialog title="Manage Ownership Contact Categories">
            {ownershipCards()}
        </Dialog>
    );
};

export default ManageContactCategoriesDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/ManageContactCategoriesDialog.tsx